import DatePickerContent from './DatePickerContent';

export default DatePickerContent;
